// app/javascript/controllers/cascading_select_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customerSelect", "relevanceSelect", "contentCategorySelect"]

  connect() {
    console.log("CascadingSelectController connected! This controller is active.");
    this.updateContentCategories();
  }

  customerChanged() {
    this.updateContentCategories();
  }

  relevanceChanged() {
    this.updateContentCategories();
  }

  async updateContentCategories() {
    const customerId = this.customerSelectTarget.value;
    const relevance = this.relevanceSelectTarget.value;

    const params = new URLSearchParams();
    if (customerId) {
      params.append('customer_id', customerId);
    }
    if (relevance) {
      params.append('relevance', relevance);
    }

    const url = `/contentcategories/filtered?${params.toString()}`;

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const contentCategories = await response.json();
      this.populateContentCategorySelect(contentCategories);
    } catch (error) {
      console.error("Fehler beim Abrufen der Inhaltskategorien:", error);
    }
  }

  // Füllt das ContentCategory Select-Feld mit den erhaltenen Optionen
  populateContentCategorySelect(contentCategories) {
    this.contentCategorySelectTarget.innerHTML = ''; // Vorherige Optionen löschen

    contentCategories.forEach(category => {
      const option = document.createElement('option');
      option.value = category.id;
      option.textContent = category.name;
      this.contentCategorySelectTarget.appendChild(option);
    });

    // Optional: Wenn es nur eine Option gibt, diese direkt auswählen
    if (contentCategories.length === 1) {
      this.contentCategorySelectTarget.value = contentCategories[0].id;
    }
  }
}